import { coaches } from './coaches'

export type Testimonial = {
  quote: string
  author: string
  role: string
  avatar: string
}

/**
 * Review copy is sample text — replace each quote with a real buyer review
 * (and the matching photo in data/coaches.ts) before launch.
 */
export const shortTestimonials: Testimonial[] = [
  {
    quote:
      'I printed Volume 3 and ran it straight out of the binder. First week of pre-season and I was not making anything up on the gym floor for the first time in six years.',
    author: coaches[0].name,
    role: coaches[0].role,
    avatar: coaches[0].avatar,
  },
  {
    quote:
      'Tryouts used to eat my whole August. The scripts and score sheets took a two-week scramble down to two afternoons, and parents stopped arguing with the placements.',
    author: coaches[1].name,
    role: coaches[1].role,
    avatar: coaches[1].avatar,
  },
  {
    quote:
      'The stunt progressions are the part I keep going back to. Level by level, with the safety checks written out — my new assistant could coach from it on day one.',
    author: coaches[2].name,
    role: coaches[2].role,
    avatar: coaches[2].avatar,
  },
]

export const moreTestimonials: Testimonial[] = [
  {
    quote:
      'Worth it for the sideline volume alone. We have cheers and timeouts mapped for every game situation instead of me yelling whatever I remember.',
    author: coaches[3].name,
    role: coaches[3].role,
    avatar: coaches[3].avatar,
  },
  {
    quote:
      'Our competition routine came together three weeks earlier than last season because the counts and transitions were already laid out for us.',
    author: coaches[4].name,
    role: coaches[4].role,
    avatar: coaches[4].avatar,
  },
  {
    quote:
      'The admin volume is the unglamorous one and the one that saved me most. Budgets, rosters, parent letters — all of it done and reusable next year.',
    author: coaches[0].name,
    role: coaches[0].role,
    avatar: coaches[0].avatar,
  },
]
